import ModalComponent from "../../../components/modals";
import LoadingFeedback, { useLoadingState } from "../../../components/loadingFeedback";
import * as yup from "yup";
import { Grid } from "@mui/material";
import {
  biomedicalManagementGetChangeLogByEquipment,
  callApiAsync
} from "../../../services/apiService";
import { useEffect, useState } from "react";
import { formatCustomDateNameLocal } from "../../../utils/dateUtils";

const HistoryModalBiomedical = ({ open, close, data }) => {
  const [loadingHistory, setLoadingHistory] = useLoadingState();
  const [callData, setCallData] = useState(null);

  const camposQueUsanFecha = [
    "Fecha de Importación",
    "Fecha de Instalación",
    "Fecha de Comercialización",
    "Eventos"
  ];

  const getBiomedicalManagementGetChangeLogByEquipment = () => {
    callApiAsync(
      () => biomedicalManagementGetChangeLogByEquipment(data),
      (result) => {
        setCallData(result);
      },
      setLoadingHistory
    );
  };

  useEffect(() => {
    if (data && open) getBiomedicalManagementGetChangeLogByEquipment();
  }, [data, open]);

  const formatIfNeeded = (fieldName, value) => {
    if (value === null || value === undefined || value === "") return "Sin valor";

    if (camposQueUsanFecha.includes(fieldName)) {
      return formatCustomDateNameLocal(value);
    }

    return value;
  };

  return (
    <div>
      <ModalComponent
        open={open}
        handleClose={close}
        title=""
        actions={<div className="HContainer j-center w-complete"></div>}
      >
        <p className="modal-history-title-xl">Última actualización</p>

        <LoadingFeedback loading={loadingHistory} rows={3}>
        {callData ? (
          <Grid container rowSpacing={2}>
            <Grid item xs={12} sm={6}>
              <p className="modal-history-title">Fecha:</p>
              <p className="modal-history-text">
                {callData.creation_date || "Sin información"}
              </p>
            </Grid>
            <Grid item xs={12} sm={6}>
              <p className="modal-history-title">Usuario:</p>
              <p className="modal-history-text">
                {callData.usuario?.nombre || "Sin información"}
              </p>
            </Grid>
            <Grid item xs={12} style={{ padding: "0" }}>
              <p className="modal-history-title">Modificaciones:</p>
              <ul style={{ margin: "0", padding: "0" }}>
                {callData.changes?.length > 0 ? (
                  callData.changes.map((item, index) => (
                    <li key={index}>
                      <strong className="modal-history-text">
                        {item.field_name}
                      </strong>
                      :{" "}
                      <em className="modal-history-text-weight">
                        {formatIfNeeded(item.field_name, item.old_value)}
                      </em>{" "}
                      →{" "}
                      <em className="modal-history-text-weight">
                        {formatIfNeeded(item.field_name, item.new_value)}
                      </em>
                    </li>
                  ))
                ) : (
                  <li>No hay cambios registrados.</li>
                )}
              </ul>
            </Grid>
          </Grid>
        ) : (
          <p className="modal-history-text">No hay información disponible.</p>
        )}
        </LoadingFeedback>
      </ModalComponent>
    </div>
  );
};

export default HistoryModalBiomedical;
